<template>
<div>
  <ListContent
        :algolia="null"
        :wrld="null"
  >
    <template v-slot:listActionPanel>
      <WrldListActionPanel :isCheckable="false" :actions="panelActions" :wrld="null" />
    </template>
    <template v-slot:list>
      <div v-if="!isLocationListLoading && items.length > 0">
        <ListItemCardBig
        v-for="(item, index) in items"
        :key="item.id"
        color="#0099ff"
        :resource="item"
        :actions="cardActions"
        :isCheckable="false"
        :isSecondLevel="true"
        @cardClicked="handleLocationSelect.apply(null, [item.id, index, item])"
      >
        <LocationsOverviewCard :key="item.id + '_location_card'" :location="item" />
      </ListItemCardBig>
      </div>
      <div v-else-if="isLocationListLoading" class="drop--sortable--tree__container">
        <div v-for="(key, index) in new Array(10)" :key="index" class="drop--sortable--tree__card drop--sortable--tree--card__topLevel placeholderLoader background--transparent">
        </div>
      </div>
      <div v-else-if="items.length < 1" class="drop--sortable--tree__container">
        {{ $t('organizations.empty_locations') }}
      </div>
    </template>
  </ListContent>
  <AddLocation :key="addLocationKey" :openMenu="addLocationMenu" @close="addLocationMenu = false" @location-added="handleSuccessAddedLocation"/>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { locationService } from '@/_services'
import { uuid } from 'vue-uuid'

import ListContent from '@/components/wrld/generic/ListContent'
import WrldListActionPanel from '@/components/wrld/generic/WrldListActionPanel'
import ListItemCardBig from '@/components/wrld/generic/ListItemCardBig'
import LocationsOverviewCard from '@/components/organizations/locations/LocationsOverviewCard'
import AddLocation from '@/components/organizations/locations/AddLocation'

export default {
  name: 'LocationsOverviewContent',
  components: {
    ListItemCardBig,
    LocationsOverviewCard,
    ListContent,
    WrldListActionPanel,
    AddLocation
  },
  props: {},
  data () {
    return {
      isLocationListLoading: false,
      addLocationMenu: false,
      addLocationKey: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.fetchLocationsList()
    })
  },
  computed: {
    ...mapGetters(['getCheckedOnPageCount', 'getSelectedResourceSecond', 'getSecondResourceOverviewList']),
    checkedOnPageCount () {
      return this.getCheckedOnPageCount(this.actualPage)
    },
    items () {
      return this.getSecondResourceOverviewList
    },
    cardActions () {
      let icons = []
      if (this.checkedOnPageCount > 0) {
        // icons.push(
        // {
        //   icon: 'archive',
        //   tooltip: 'Archive',
        //   callback: this.archiveDrops,
        //   loading: false
        // },
        // )
      }
      return icons
    },
    panelActions () {
      let icons = []
      icons.push({
        icon: 'fas fa-plus',
        tooltip: this.$t('locations.add_location'),
        callback: this.handleAddLocation,
        loading: false,
        iconSize: '18'
      })
      return icons
    }
  },
  methods: {
    ...mapActions({
      updateResourceSecond: 'updateResourceSecond',
      setLocationDetails: 'setLocationDetails',
      setSecondResourceOverviewList: 'setSecondResourceOverviewList'
    }),
    async handleLocationSelect (locationID, index, location) {
      if (this.getSelectedResourceSecond !== null) {
        // const location = await organizationService.getLocation(locationID)
        // console.log(location)
        const resourceModifier = { // TODO: MOCKED
          createdAt: 1573127080000,
          createdBy: 'SAP integration',
          lastUpdateAt: 1573199880000,
          lastUpdateBy: 'Bob Kennedy'
        }
        this.updateResourceSecond({ resource: { ...location, objectID: location.id, resourceModifier: resourceModifier } })
        this.setLocationDetails({ locationDetails: { ...location, objectID: location.id, resourceModifier: resourceModifier } })
      }
    },
    fetchLocationsList () {
      this.isLocationListLoading = true
      locationService.getListLocations({ organizationID: this.$route.params.organizationID }).then((items) => {
        this.isLocationListLoading = false
        this.setSecondResourceOverviewList({ items })
      }).finally(() => {
        this.isLocationListLoading = false
      })
    },
    handleAddLocation () {
      this.addLocationKey = uuid.v1()
      this.$nextTick(() => {
        this.addLocationMenu = true
      })
    },
    handleSuccessAddedLocation () {
      // this.fetchLocationsList()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
